export default "//static.glanacion.com/v2/checkout-nuevo/images/image-promo-banner.png";